import React, { Component, PropTypes } from 'react'
import { Form, Icon, Input, Button, Checkbox, Tabs, Row, Col, Modal } from 'antd'
import { connect } from 'react-redux'

import Footer from '../common/NHFooter/index';
import {receiveUserInfo,userLogin} from '../../actions/login.js';

const { TabPane } = Tabs
const FormItem = Form.Item

import styles from './index.css'
import logo from '../../styles/images/logo-l.png';
import { JSEncrypt } from 'jsencrypt';
const pubKey = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ8DUCb0CEFATRWU8BtBL42RvsdFBcpxYNfsg0P1f7Rd1qKLtqLSBBVGrJu148CdCAkxwKOsjvj5D4eMeDQCd18CAwEAAQ==";
import hexSha1 from 'hex-sha1';
const URL_PREFIX = ''; //统一前缀    
const reqGetCaptcha = `${URL_PREFIX}captchaServlet?v=`;//验证码下载路径  

var querystring = require('querystring');//将POST请求参数转换请求字符串


@connect((state) => {
    const { hashUrl } = state
    return { hashUrl }
})
class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'tab1',
            active: {},
            count: 0,
            loading:false,
            validateUrl: '',
            captchaVisible: false,//验证码是否可见
        };
    }

    componentWillMount () {
        if(this.state.type=='tab1') {
            
        }
        this.getSetting();//获取配置，是否开启验证码
    }
    //获取配置，是否开启验证码
    getSetting() {
      fetch(`${URL_PREFIX}ng/captcha/status`, {
          method: "GET",
          credentials: "include",
          headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "X-Requested-With": "XMLHttpRequest",
              "appId": "ly-zhxg"
          }
      })
          .then((response) => response.json())
          .then((res) => {
              if (res.meta && res.meta.statusCode === 200) {
                  this.setState({
                      captchaVisible: res.data,
                  }, () => {
                      if (res.data) {
                          this.changeCaptcha();
                      }
                  })
              } else {
                  this.setState({
                      captchaVisible: false,
                  })
              }
              return res;
          })
          .catch((error) => {
              // 网络请求失败返回执行该回调函数，得到错误信息
              Modal.error({ title: '错误提示', content: '网络请求异常,请联系管理员' });
              return error;
          })
    }

    handleAccountSubmit = (e) => {
      e.preventDefault();
      if (this.state.type === 'tab1') {
          this.props.form.validateFields(['username', 'password', 'captcha'], { force: true },
              (err, values) => {
                  if (!err) {
                      let encrypt = new JSEncrypt();
                      encrypt.setPublicKey(pubKey);
                      let encryptPassword = encrypt.encrypt(values.password); //password为需要加密的字段
                      let timestamp = new Date().getTime();
                      let arr = [];
                      arr.push("username="+values.username, "password="+encryptPassword, "timestamp="+timestamp);
                      let digest = hexSha1(arr.join(","));
                      
                      let params = {
                          username: values.username,
                          password: encryptPassword,
                          encryptTransfer: true,
                          timestamp:timestamp,
                          digest:digest
                      };

                      //验证码开启
                      if (this.state.captchaVisible) {
                          params = {
                              ...params,
                              captcha: values.captcha,
                              systemId: 'ly-zhxg'
                          }
                      }
                      this.setState({
                          loading: true
                      });
                      userLogin(params, () => {
                          this.setState({
                              loading: false
                          }, () => { this.getSetting() });
                      });
                  } else {

                  }
              }
          );
      } else {

      }
  }

  changeCaptcha() {
      this.setState({
          validateUrl: reqGetCaptcha + (new Date().getMilliseconds()),
      })
  }
    onGetCaptcha = () => {
        let count = 59;
        this.setState({ count });
        this.interval = setInterval(() => {
            count -= 1;
            this.setState({ count });
            if (count === 0) {
                clearInterval(this.interval);
            }
        }, 1000);
    }

    render() {
        const { type, count } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <header style={{ marginBottom: 70, textAlign: 'center' }}>
                        <a href="javascript:;">
                            <img alt="logo" style={{maxWidth:500,maxHeight:100}}
                            src={'front/zhxg-unauth/xtglSchoolMng/downloadSchoolPictureByType?type=dlylogo'} onError={(e)=>{e.target.src = logo}}/>
                        </a>
                    </header>
                    <div className={styles.main}>
                        <Form onSubmit={this.handleAccountSubmit}>
                            <FormItem>
                                {getFieldDecorator('username', {
                                    rules: [{ required: true, message: '请输入您的账号！' }],
                                })(
                                    <Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入用户名" />
                                )}
                            </FormItem>
                            <FormItem>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: '请输入密码！' }],
                                })(
                                    <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="请输入密码" />
                                )}
                            </FormItem>
                            {
                                this.state.captchaVisible ?
                                    <FormItem>
                                        {getFieldDecorator('captcha', {
                                            rules: [{ required: true, message: '请输入验证码！' }],
                                        })(
                                            <div>
                                                <Input size="large" type="text" placeholder="请输入验证码" style={{ width: '58%', float: 'left' }} />
                                                <div>
                                                    <span onClick={() => this.changeCaptcha()}>
                                                        <img src={this.state.validateUrl} />
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </FormItem>
                                    : null
                            }
                            <FormItem>
                                <Button className={styles.submit} type="primary" size="large" htmlType="submit" loading={this.state.loading}>
                                    登录
                                </Button>
                            </FormItem>
                            <FormItem>
                                {getFieldDecorator('remember', {
                                    valuePropName: 'checked',
                                    initialValue: true,
                                })(
                                    <Checkbox style={{ float: 'right' }}>记住登录</Checkbox>
                                )}
                            </FormItem>
                        </Form>
                    </div>
                </div>
                <div style={{margin:'48px 0 24px'}}> 
                    <Footer />  
                </div>
            </div>
        )
    }
}
const Login = Form.create()(LoginPage);
export default Login



// WEBPACK FOOTER //
// ./components/Login/index.js